import React from "react";
import { Link, NavLink } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import logo from "../components/images/ipl-logo-new-old.png";

import { useStateContext } from "../contexts/ContextProvider";
import {
  MdScore,
  MdLocalOffer,
  MdEmojiEvents,
  MdEventNote,
  MdTableChart,
} from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { GiGroundbreaker } from "react-icons/gi";

const links = [
  {
    links: [
      {
        name: "Score",
        route: "livescore",
        icon: <MdScore />,
      },
      {
        name: "Table",
        route: "pointtable",
        icon: <MdTableChart />,
      },
      {
        name: "Teams",
        route: "teams",
        icon: <RiTeamFill />,
      },
      {
        name: "Stadiums",
        route: "stadiums",
        icon: <GiGroundbreaker />,
      },
      {
        name: "Results",
        route: "results",
        icon: <MdEmojiEvents />,
      },
      {
        name: "Records",
        route: "matches",
        icon: <MdEventNote />,
      },
      {
        name: "Sponsors",
        route: "sponsors",
        icon: <MdLocalOffer />,
      },
      {
        name: "Final Report",
        route: "final-match-report",
        icon: <MdEmojiEvents />,
      },
    ],
  },
];

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } =
    useStateContext();

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink =
    "flex items-center gap-3 pl-4 pt-3 pb-2.5 rounded-lg text-white bg-gray-800 text-lg m-2";
  const normalLink =
    "flex items-center gap-3 pl-4 pt-3 pb-2.5 rounded-lg text-lg text-gray-100 dark:text-gray-200 hover:bg-gray-800 m-2";

  return (
    <div className="relative z-50">
      {screenSize <= 900 && activeMenu && (
        <div
          className="fixed inset-0 z-40 bg-black/50"
          onClick={() => setActiveMenu(false)}
        />
      )}

      <div
        className={`fixed left-0 top-0 h-screen bg-gradient-to-b from-blue-400 to-blue-900 transition-transform duration-300 ease-in-out z-50
          ${screenSize <= 900 ? (activeMenu ? "translate-x-0" : "-translate-x-full") : "translate-x-0"}
          w-64
        `}
      >
        <div className="overflow-y-auto px-4 pt-16 pb-4 h-full">
          <div className="flex justify-between items-center mb-12">
            <Link
              to="/"
              className="flex gap-3 items-center text-xl font-extrabold tracking-tight text-white"
            >
              <img src={logo} alt="ipl" className="h-16" />
            </Link>
            {screenSize <= 900 && (
              <TooltipComponent content="Close Menu" position="BottomCenter">
                <button
                  type="button"
                  onClick={() => setActiveMenu(false)}
                  className="p-2 text-white rounded-full hover:bg-white/20"
                >
                  <MdOutlineCancel className="text-2xl" />
                </button>
              </TooltipComponent>
            )}
          </div>

          <div className="flex flex-col gap-2">
            {links.map((item, index) => (
              <div key={index}>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.route}`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : "",
                    })}
                    className={({ isActive }) =>
                      isActive ? activeLink : normalLink
                    }
                  >
                    {link.icon}
                    <span className="capitalize">{link.name}</span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
